<template>
  <div id="repayView">
    <headNav>
      <div slot="headNavText">Trung tâm thanh toán</div>
    </headNav>
    <div style="height:1.3rem;width: 100%"></div>
    <!--    <a :href="url">打开</a>-->
    <iframe :src="url" frameborder="0" style="position:absolute;height: calc(100% + 2.9rem);width: 100%;"></iframe>
  </div>
</template>

<script>
  import headNav from "../../HeadNav/headNav";
  export default {
    name: "repayView",
    data(){
      return{
        url:''
      }
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      this.$store.commit('edit', true);
      this.url = this.$route.query.url;
      setTimeout(()=>{
        this.$store.commit('edit', false);
      },2000)
    },
    components: {
      headNav
    },

  }
</script>

<style scoped>
  #repayView{
    position: absolute;
    /*height: calc(100% + 1.7rem);*/
    height: 100%;
    width:100%;
    top: 0;
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/loanRecord/repay/repayView.vue